module.exports = "/remote-dist/8b810b800e401587925559385cd7c9c7.jpg";